Controller = App.loadClass 'core::Angular/Controller'

class exports.ScoresController extends Controller
    constructor: (@scope, @transitions, @service, @state, @http, @transition$) ->
        super

        @scope.fullpage = true
        @scope.dataLoaded = false
        @scope.close = @close
        @scope.source = { selection: null }
        @scope.updateChartData = @updateChartData
        @scope.hasData = @hasData
        @scope.service = @service

        @scope.labels = []
        @sourceData = []
        @scope.data = []
        @scope.colors = []
        @scope.series = []
        @scope.options =
            responsive: false
            layout:
                padding: 15
            animation:
                duration: 0
            scale:
                pointLabels:
                    fontSize: 14
                ticks:
                    min: 0
                    max: 100
                    stepSize: 20
            tooltips:
                # Hide NaNs in benchmarks for Water Quality, Soil Carbon (state only), and Biodiversity
                filter: (entry) -> entry.yLabel

        @scope.displayMode =
            state: false
            national: false

        @scope.$on 'fieldprintChanged', (event, fpcResult) =>
            if fpcResult.id is @transition$.params().id
                @updateScores fpcResult

        @service.onDataLoaded @scope, () =>
            @scope.dataLoaded = true
            @scope.source.selection = if @service.fpcResult.data.irrigated then 'irrigated' else 'dryland'

            @updateScores @service.fpcResult

        # Just in case we are loading directly into the scores state, we need to get the data for ourselves
        if @service.fpcResult?.id isnt @transition$.params().id
            @service.reset()
            @service.loadFieldprint @transition$.params().id

    updateScores: (fpcResult) =>
        prepareForPresentation = (scores) =>
            scores.map (score) =>
                if score then score.toFixed(1) else null

        @service.fpcResult = fpcResult
        @sourceData['dryland'] = fpcResult.dryland_scores?.map prepareForPresentation
        @sourceData['irrigated'] = fpcResult.irrigated_scores?.map prepareForPresentation
        @scope.updateChartData()

    hasData: (type) =>
        return @sourceData[type]?.length > 0

    updateChartData: () =>
        @scope.data = []

        sourceData = angular.copy @sourceData[@scope.source.selection]

        if not sourceData?.length
            return

        @scope.labels = [
            'Land Use'
            ['Soil', 'Conservation']
            ['Soil', 'Carbon']
            ['Irrigation', 'Water Use']
            ['Energy', 'Use']
            ['Greenhouse Gas', 'Emissions']
            ['Water', 'Quality']
            ['Biodiversity']
        ]

        # Swap Irrigation Water user -> Greenhouse Gas Emissions -> Soild Carbon to match FtM display
        sourceData.map (data) ->
            soilCarbon = data[5]
            data[5] = data[3]
            data[3] = data[2]
            data[2] = soilCarbon

        if @scope.source.selection is 'dryland'
            # Remove Irrigation Water Use axis and data
            @scope.labels.splice 3, 1
            sourceData[0].splice 3, 1
            sourceData[1].splice 3, 1
            sourceData[2].splice 3, 1

        @scope.data = [sourceData[0]]
        @scope.colors = ["rgb(0,161,38)"]
        @scope.series = ['You']
        @scope.datasetOverride = [
            {
                backgroundColor: "rgba(0,161,38,.5)"
                pointStyle: 'circle'
                pointBorderColor: 'rgb(0,161,38)'
                pointBorderWidth: 1
            }
        ]

        if @scope.displayMode.state
            @scope.data.push sourceData[1]
            @scope.colors.push "rgb(0,85,204)"
            @scope.series.push 'State Benchmark'
            @scope.datasetOverride.push
                fill: false
                borderColor: 'rgba(0,0,0,0)'
                pointStyle: 'circle'
                pointBorderColor: 'rgb(0,85,204)'
                pointBorderWidth: 3

        if @scope.displayMode.national
            @scope.data.push sourceData[2]
            @scope.colors.push "rgb(248,148,6)"
            @scope.series.push 'National Benchmark'
            @scope.datasetOverride.push
                fill: false
                borderColor: 'rgba(0,0,0,0)'
                pointStyle: 'circle'
                pointBorderColor: 'rgb(248,148,6)'
                pointBorderWidth: 5

    close: () =>
        @state.go '^'
